/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Newsletter_SendingInputs */

const ja_playdata_home_newsletter_sending = /** @type {(inputs: Playdata_Home_Newsletter_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`送信中…`)
};

const en_playdata_home_newsletter_sending = /** @type {(inputs: Playdata_Home_Newsletter_SendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending…`)
};

/**
* | output |
* | --- |
* | "Sending…" |
*
* @param {Playdata_Home_Newsletter_SendingInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_newsletter_sending = /** @type {((inputs?: Playdata_Home_Newsletter_SendingInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Newsletter_SendingInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_newsletter_sending(inputs)
	return en_playdata_home_newsletter_sending(inputs)
});